export default __webpack_public_path__ + "static/media/imagenet.0f9bddb6.svg";